"use strict";

exports.__esModule = true;
exports["default"] = CircleEmpty;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleEmpty(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.004 31.941c-8.79 0-15.941-7.145-15.941-15.929C.063 7.219 7.215.066 16.004.066c8.786 0 15.934 7.153 15.934 15.946 0 8.784-7.148 15.929-15.934 15.929zm0-30.001c-7.755 0-14.066 6.314-14.066 14.072 0 7.748 6.311 14.053 14.066 14.053 7.751 0 14.058-6.304 14.058-14.053 0-7.758-6.307-14.072-14.058-14.072z"
  }));
}